import Snackbar from "./component";
import { asVariation } from "../../../helper/variations";

Snackbar.Primary = asVariation(Snackbar, "primary", { typeStyle: "primary" });

export { Snackbar };
